import { NAVY, GOLD, WHITE } from "./palette";

// Global CSS for the app. Rendered as <style>{globalCss}</style>.
// Note: template-literal interpolation of palette constants happens
// once at import time, so changing the palette requires a reload.
export const globalCss = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Inter',sans-serif;background:#f5f6f8;color:#1a1f36;font-size:14px}
  ::-webkit-scrollbar{width:5px}::-webkit-scrollbar-track{background:#f0f0f0}::-webkit-scrollbar-thumb{background:#c1c7d0;border-radius:3px}

  /* ── App shell ── */
  .app{display:flex;min-height:100vh}

  /* ── Sidebar ── */
  .sidebar{width:224px;min-width:224px;background:${NAVY};display:flex;flex-direction:column;position:sticky;top:0;height:100vh;overflow-y:auto}
  .sidebar-logo{padding:20px 20px 16px;border-bottom:1px solid rgba(255,255,255,.08)}
  .sidebar-logo h1{font-family:'Inter',sans-serif;font-size:16px;font-weight:700;color:${WHITE};line-height:1.3;letter-spacing:-.3px}
  .sidebar-logo span{color:${GOLD}}
  .sidebar-logo p{color:rgba(255,255,255,.4);font-size:11px;margin-top:3px;font-weight:400}
  .nav{padding:12px 10px;flex:1}
  .nav-section{font-size:10px;font-weight:600;letter-spacing:.08em;color:rgba(255,255,255,.3);padding:14px 10px 6px;text-transform:uppercase}
  .nav-item{display:flex;align-items:center;gap:10px;padding:9px 12px;border-radius:6px;cursor:pointer;font-size:13px;font-weight:500;color:rgba(255,255,255,.6);transition:.12s;margin-bottom:1px;line-height:1}
  .nav-item:hover{background:rgba(255,255,255,.07);color:rgba(255,255,255,.9)}
  .nav-item.active{background:rgba(244,193,32,.15);color:${GOLD};font-weight:600}
  .nav-item svg{width:16px;height:16px;flex-shrink:0;opacity:.8}
  .nav-item.active svg{opacity:1}
  .sidebar-footer{padding:14px 16px;border-top:1px solid rgba(255,255,255,.07);font-size:11px;color:rgba(255,255,255,.25)}

  /* ── Main area ── */
  .main{flex:1;overflow:auto;background:#f5f6f8;min-width:0}

  /* ── Topbar ── */
  .topbar{background:${WHITE};border-bottom:1px solid #e3e8ef;padding:0 28px;height:56px;display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;z-index:10}
  .topbar h2{font-size:16px;font-weight:600;color:#1a1f36;letter-spacing:-.2px}
  .topbar-actions{display:flex;gap:8px;align-items:center}
  .topbar-date{font-size:12px;color:#8993a4;padding:0 4px}

  /* ── Page content ── */
  .content{padding:24px 28px}

  /* ── Cards ── */
  .card{background:${WHITE};border-radius:8px;border:1px solid #e3e8ef;padding:20px}
  .card-title{font-size:13px;font-weight:600;color:#1a1f36;margin-bottom:14px;letter-spacing:-.1px}

  /* ── Stat cards ── */
  .stats-row{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin-bottom:20px}
  .stat-card{background:${WHITE};border-radius:8px;border:1px solid #e3e8ef;padding:18px 20px}
  .stat-card:hover{border-color:#c5cdd8;box-shadow:0 2px 8px rgba(0,0,0,.06)}
  .stat-label{font-size:11px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:#8993a4;margin-bottom:8px}
  .stat-value{font-size:26px;font-weight:700;color:#1a1f36;letter-spacing:-.5px;line-height:1}
  .stat-sub{font-size:11px;color:#8993a4;margin-top:5px}
  .stat-accent{width:3px;height:32px;border-radius:2px;background:${GOLD};margin-bottom:10px}

  /* ── Buttons ── */
  .btn{padding:8px 16px;border-radius:6px;border:none;cursor:pointer;font-family:'Inter',sans-serif;font-size:13px;font-weight:500;transition:.12s;display:inline-flex;align-items:center;gap:6px;line-height:1;white-space:nowrap}
  .btn:disabled{opacity:.5;cursor:not-allowed}
  .btn-primary{background:${NAVY};color:${WHITE}}
  .btn-primary:hover:not(:disabled){background:#0a3589}
  .btn-gold{background:${GOLD};color:${NAVY};font-weight:600}
  .btn-gold:hover:not(:disabled){background:#e6b410}
  .btn-ghost{background:transparent;color:#42526e;border:1px solid #dfe1e6}
  .btn-ghost:hover:not(:disabled){background:#f4f5f7;border-color:#c1c7d0}
  .btn-danger{background:#de350b;color:${WHITE}}
  .btn-danger:hover{background:#bf2600}
  .btn-sm{padding:5px 12px;font-size:12px}
  .btn-xs{padding:4px 9px;font-size:11px;border-radius:4px}

  /* ── Table ── */
  .table-wrap{overflow-x:auto}
  table{width:100%;border-collapse:collapse}
  thead tr{border-bottom:2px solid #f0f2f5}
  th{font-size:11px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#8993a4;padding:8px 14px;text-align:left;white-space:nowrap}
  td{padding:11px 14px;font-size:13px;border-bottom:1px solid #f4f5f7;color:#253858}
  tr:last-child td{border-bottom:none}
  tr:hover td{background:#fafbfc}

  /* ── Badges ── */
  .badge{display:inline-flex;align-items:center;padding:2px 9px;border-radius:20px;font-size:11px;font-weight:600;letter-spacing:.02em}
  .badge-green{background:#e3fcef;color:#006644}
  .badge-gold{background:#fffae6;color:#974f0c}
  .badge-blue{background:#deebff;color:#0747a6}
  .badge-gray{background:#f4f5f7;color:#42526e}
  .badge-red{background:#ffebe6;color:#bf2600}
  .badge-purple{background:#eae6ff;color:#403294}

  /* ── Forms ── */
  .form-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}
  .form-group{display:flex;flex-direction:column;gap:5px}
  .form-group.full{grid-column:1/-1}
  label{font-size:12px;font-weight:500;color:#42526e}
  input,select,textarea{padding:8px 11px;border:1px solid #dfe1e6;border-radius:5px;font-family:'Inter',sans-serif;font-size:13px;color:#253858;outline:none;transition:.12s;background:${WHITE}}
  input:focus,select:focus,textarea:focus{border-color:${NAVY};box-shadow:0 0 0 2px rgba(7,44,118,.12)}
  input::placeholder{color:#b3bac5}
  textarea{resize:vertical;min-height:72px}
  select{cursor:pointer}

  /* ── Modal ── */
  .modal-overlay{position:fixed;inset:0;background:rgba(9,30,66,.54);z-index:100;display:flex;align-items:center;justify-content:center;padding:20px}
  .modal{background:${WHITE};border-radius:8px;width:100%;max-width:560px;max-height:92vh;overflow-y:auto;box-shadow:0 20px 60px rgba(9,30,66,.25)}
  .modal-header{padding:18px 24px;border-bottom:1px solid #e3e8ef;display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;background:${WHITE};z-index:1}
  .modal-header h3{font-size:16px;font-weight:600;color:#1a1f36;letter-spacing:-.2px}
  .modal-body{padding:20px 24px}
  .modal-footer{padding:14px 24px;border-top:1px solid #e3e8ef;display:flex;justify-content:flex-end;gap:8px;position:sticky;bottom:0;background:${WHITE}}
  .close-btn{background:none;border:none;cursor:pointer;color:#b3bac5;font-size:20px;line-height:1;padding:2px}
  .close-btn:hover{color:#42526e}

  /* ── Week grid ── */
  .week-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:8px}
  .day-col{background:${WHITE};border-radius:8px;border:1px solid #e3e8ef;overflow:hidden}
  .day-header{background:#f4f5f7;color:#42526e;font-size:11px;font-weight:600;text-align:center;padding:8px 4px;text-transform:uppercase;letter-spacing:.05em}
  .day-header.today{background:${NAVY};color:${WHITE}}
  .day-jobs{padding:6px}
  .job-chip{background:#f4f5f7;border-left:3px solid ${NAVY};border-radius:4px;padding:5px 7px;margin-bottom:4px;font-size:11px;cursor:pointer;transition:.1s}
  .job-chip:hover{background:#ebecf0}
  .job-chip.done{background:#e3fcef;border-color:#36b37e;opacity:.7}
  .job-chip .client-name{font-weight:600;color:#253858;display:block;font-size:11px}
  .job-chip.done .client-name{color:#006644;text-decoration:line-through}

  /* ── Route ── */
  .route-item{display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:8px;border:1px solid #e3e8ef;margin-bottom:8px;background:${WHITE};transition:.12s}
  .route-item:hover{border-color:#b3bac5;box-shadow:0 2px 6px rgba(0,0,0,.06)}
  .route-item.completed{opacity:.5}
  .route-num{width:30px;height:30px;border-radius:50%;background:${NAVY};color:${WHITE};font-weight:700;font-size:13px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
  .route-num.done{background:#36b37e}
  .route-info{flex:1}
  .route-name{font-weight:600;font-size:13px;color:#253858}
  .route-addr{font-size:12px;color:#8993a4;margin-top:2px}

  /* ── Today banner ── */
  .today-banner{background:${NAVY};border-radius:8px;padding:20px 24px;color:${WHITE};margin-bottom:20px;display:flex;align-items:center;justify-content:space-between}
  .today-banner h3{font-size:17px;font-weight:700;letter-spacing:-.3px}
  .today-banner p{font-size:13px;opacity:.6;margin-top:3px}
  .today-num{font-size:52px;font-weight:800;color:${GOLD};line-height:1;letter-spacing:-2px}

  /* ── Tabs ── */
  .tabs{display:flex;gap:0;border-bottom:2px solid #e3e8ef;margin-bottom:16px}
  .tab{padding:8px 16px;cursor:pointer;font-size:13px;font-weight:500;color:#8993a4;border-bottom:2px solid transparent;margin-bottom:-2px;transition:.12s}
  .tab:hover{color:#253858}
  .tab.active{color:${NAVY};border-bottom-color:${NAVY};font-weight:600}

  /* ── Price tag ── */
  .price-tag{background:#f4f5f7;border:1px solid #dfe1e6;border-radius:6px;padding:12px 16px;font-size:24px;font-weight:700;color:#1a1f36;text-align:center;letter-spacing:-.5px}
  .price-tag span{font-size:13px;font-weight:400;color:#8993a4}

  /* ── Grid ── */
  .grid-2{display:grid;grid-template-columns:1fr 1fr;gap:16px}

  /* ── Empty state ── */
  .empty{text-align:center;padding:40px 20px;color:#b3bac5}
  .empty p{font-size:13px;margin-top:8px}

  /* ── Alerts ── */
  .alert{padding:10px 14px;border-radius:6px;font-size:13px;margin-bottom:12px}
  .alert-success{background:#e3fcef;color:#006644;border:1px solid #abf5d1}
  .alert-error{background:#ffebe6;color:#bf2600;border:1px solid #ffbdad}
  .alert-info{background:#deebff;color:#0747a6;border:1px solid #b3d4ff}

  /* ── Stripe field ── */
  .stripe-field{padding:8px 11px;border:1px solid #dfe1e6;border-radius:5px;background:${WHITE};transition:.12s;min-height:38px}
  .stripe-field.focused{border-color:${NAVY};box-shadow:0 0 0 2px rgba(7,44,118,.12)}
  .stripe-field.error{border-color:#de350b}

  /* ── Steps ── */
  .steps{display:flex;gap:0;margin-bottom:22px}
  .step{flex:1;display:flex;flex-direction:column;align-items:center;position:relative}
  .step:not(:last-child)::after{content:'';position:absolute;top:13px;left:50%;width:100%;height:2px;background:#e3e8ef;z-index:0}
  .step-dot{width:26px;height:26px;border-radius:50%;border:2px solid #dfe1e6;background:${WHITE};display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:600;color:#b3bac5;position:relative;z-index:1}
  .step-dot.active{border-color:${NAVY};background:${NAVY};color:${WHITE}}
  .step-dot.done{border-color:#36b37e;background:#36b37e;color:${WHITE}}
  .step-label{font-size:11px;margin-top:5px;color:#8993a4;text-align:center}
  .step-label.active{color:${NAVY};font-weight:600}

  /* ── Card display ── */
  .card-display{background:linear-gradient(135deg,${NAVY},#1547b5);border-radius:8px;padding:14px 18px;color:${WHITE};display:flex;align-items:center;justify-content:space-between}

  /* ── Divider ── */
  .divider{height:1px;background:#e3e8ef;margin:16px 0}

  /* ── Section header ── */
  .section-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:16px}
  .section-title{font-size:14px;font-weight:600;color:#1a1f36;letter-spacing:-.2px}

  /* ── Spinner ── */
  @keyframes spin{to{transform:rotate(360deg)}}
  .spinner{width:14px;height:14px;border:2px solid rgba(255,255,255,.3);border-top-color:${WHITE};border-radius:50%;animation:spin .7s linear infinite;display:inline-block}
  .spinner-dark{border-color:rgba(7,44,118,.15);border-top-color:${NAVY}}

  /* ── Profile ── */
  .profile-header{display:flex;align-items:flex-start;justify-content:space-between;flex-wrap:wrap;gap:12px;margin-bottom:16px}
  .profile-avatar{width:48px;height:48px;border-radius:50%;background:${NAVY};color:${GOLD};display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:700;flex-shrink:0}
  .btn-danger{background:#ffebe6;color:#bf2600;border:none;font-family:'Inter',sans-serif;font-size:12.5px;font-weight:500;padding:7px 14px;border-radius:6px;cursor:pointer;transition:.12s;display:inline-flex;align-items:center;gap:5px}
  .btn-danger:hover{background:#ffbdad}
  .badge-purple{background:#eae6ff;color:#403294}

  /* ── Hide number input spinners ── */
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button { -webkit-appearance:none; margin:0; }
  input[type=number] { -moz-appearance:textfield; }

  /* ── Misc ── */
  .flex{display:flex}.items-center{align-items:center}.justify-between{justify-content:space-between}.gap-2{gap:8px}.gap-3{gap:12px}
  .text-sm{font-size:12px}.text-gray{color:#8993a4}.font-bold{font-weight:600}
  .mt-4{margin-top:16px}.mb-4{margin-bottom:16px}

  /* ── Sidebar nav badge ── */
  .nav-badge{margin-left:auto;background:rgba(244,193,32,.2);color:${GOLD};font-size:10px;font-weight:700;padding:1px 6px;border-radius:10px}
  .nav-badge.red{background:rgba(222,53,11,.25);color:#ff8f73}

  /* ── Topbar avatar + bell ── */
  .topbar-icon{width:32px;height:32px;border-radius:6px;border:1px solid #e3e8ef;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#8993a4;position:relative}
  .topbar-icon:hover{background:#f4f5f7;color:#253858}
  .topbar-avatar{width:32px;height:32px;border-radius:50%;background:${NAVY};display:flex;align-items:center;justify-content:center;color:${GOLD};font-weight:700;font-size:12px;cursor:pointer}
  .notif-badge{position:absolute;top:-4px;right:-4px;width:16px;height:16px;border-radius:50%;background:#de350b;color:#fff;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;border:2px solid ${WHITE}}

  /* ── Activity feed ── */
  .activity-item{display:flex;gap:10px;padding:8px 0;border-bottom:1px solid #f4f5f7}
  .activity-item:last-child{border-bottom:none}
  .activity-dot{width:8px;height:8px;border-radius:50%;margin-top:4px;flex-shrink:0}
  .activity-text{font-size:12px;color:#253858;line-height:1.4}
  .activity-time{font-size:11px;color:#b3bac5;margin-top:2px}

  /* ── Revenue chart ── */
  .chart-bar-wrap{display:flex;align-items:flex-end;gap:6px;height:80px;padding-top:8px}
  .chart-bar-col{flex:1;display:flex;flex-direction:column;align-items:stretch}
  .chart-bar{flex:1;background:#f0f2f5;border-radius:3px 3px 0 0;position:relative;overflow:hidden}
  .chart-bar-fill{position:absolute;bottom:0;left:0;right:0;border-radius:3px 3px 0 0;transition:.4s}
  .chart-label{font-size:9px;color:#b3bac5;text-align:center;margin-top:4px;font-weight:500}

  /* ── Quick actions ── */
  .quick-action{display:flex;flex-direction:column;align-items:center;gap:6px;padding:12px 8px;border-radius:8px;border:1px solid #e3e8ef;background:${WHITE};cursor:pointer;transition:.15s;text-align:center}
  .quick-action:hover{border-color:${NAVY};background:#f0f4ff}
  .qa-icon{width:32px;height:32px;border-radius:8px;background:#f4f5f7;display:flex;align-items:center;justify-content:center;font-size:16px}
  .quick-action span{font-size:11px;font-weight:500;color:#42526e}

  /* ── Stat trend ── */
  .stat-trend{font-size:11px;font-weight:600;margin-top:4px}
  .trend-up{color:#36b37e}.trend-down{color:#de350b}

  /* ── Weather ── */
  .weather-widget{background:linear-gradient(135deg,${NAVY},#1547b5);border-radius:8px;padding:16px;color:${WHITE}}

  /* ── Progress ── */
  .progress-bar{height:6px;background:#f0f2f5;border-radius:3px;overflow:hidden}
  .progress-fill{height:100%;border-radius:3px;transition:.4s}

  /* ── Map ── */
  .map-container{background:#e8edf2;border-radius:8px;overflow:hidden;position:relative;border:1px solid #e3e8ef}
  .map-marker{position:absolute;transform:translate(-50%,-50%);cursor:pointer;transition:.15s;z-index:2}
  .map-marker:hover{z-index:10;transform:translate(-50%,-50%) scale(1.3)}
  .map-tooltip{position:absolute;background:${WHITE};border:1px solid #e3e8ef;border-radius:6px;padding:8px 10px;font-size:11px;white-space:nowrap;box-shadow:0 4px 12px rgba(0,0,0,.12);z-index:20;bottom:calc(100%+8px);left:50%;transform:translateX(-50%);pointer-events:none;min-width:140px}
  .map-tooltip::after{content:'';position:absolute;top:100%;left:50%;transform:translateX(-50%);border:5px solid transparent;border-top-color:${WHITE}}
  .map-legend{position:absolute;bottom:12px;left:12px;background:rgba(255,255,255,.96);border-radius:8px;padding:10px 12px;font-size:11px;border:1px solid #e3e8ef;box-shadow:0 2px 8px rgba(0,0,0,.08)}
  .legend-row{display:flex;align-items:center;gap:6px;margin-bottom:4px;color:#42526e;font-weight:500;font-size:11px}
  .legend-row:last-child{margin-bottom:0}
  .map-controls{position:absolute;top:12px;right:12px;display:flex;flex-direction:column;gap:4px;z-index:5}
  .map-ctrl-btn{width:28px;height:28px;background:${WHITE};border:1px solid #e3e8ef;border-radius:4px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:14px;color:#42526e;font-weight:700}
  .map-ctrl-btn:hover{background:#f4f5f7}
  .map-block{position:absolute;background:#d4dbe4;border-radius:2px}
  .map-road-h{position:absolute;height:1px;background:#fff;left:0;right:0;opacity:.3}
  .map-road-v{position:absolute;width:1px;background:#fff;top:0;bottom:0;opacity:.3}
  .grid-3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:14px}
`;
